import { useState } from 'react';

import classes from './NewsletterForm.module.scss';
import { FORMSUBMIT_URL } from '../../siteConfig';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const NewsletterForm = ({ compact = false, onSubscribed }) => {
    const [email, setEmail] = useState('');
    const [honeypot, setHoneypot] = useState('');
    const [status, setStatus] = useState('idle'); // idle | sending | success | error
    const [message, setMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (status === 'sending') return;

        const trimmed = email.trim();

        if (!trimmed) {
            setStatus('error');
            setMessage('Please enter your email address.');
            return;
        }

        if (!EMAIL_PATTERN.test(trimmed)) {
            setStatus('error');
            setMessage('Please enter a valid email address.');
            return;
        }

        // Honeypot filled means a bot submitted the form. Fake success and drop it.
        if (honeypot) {
            setStatus('success');
            setMessage("You're on the list! We'll be in touch soon.");
            return;
        }

        setStatus('sending');
        setMessage('');

        try {
            const response = await fetch(FORMSUBMIT_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    email: trimmed,
                    _subject: 'New Abayatique newsletter signup',
                    _template: 'table',
                    _captcha: 'false',
                }),
            });

            if (!response.ok) throw new Error(`Request failed: ${response.status}`);

            setStatus('success');
            setMessage("You're on the list! We'll be in touch soon.");
            setEmail('');

            if (onSubscribed) onSubscribed();
        } catch (error) {
            setStatus('error');
            setMessage('Something went wrong. Please try again in a moment.');
        }
    };

    if (status === 'success') {
        return (
            <div className={`${classes.Newsletter} ${compact ? classes.Compact : ''}`}>
                <div className={classes.SuccessMessage}>{message}</div>
            </div>
        );
    }

    return (
        <div className={`${classes.Newsletter} ${compact ? classes.Compact : ''}`}>
            <form className={classes.Form} onSubmit={handleSubmit} noValidate>
                {/* Honeypot — hidden from users, catches bots that fill every field. */}
                <input
                    type="text"
                    name="_honey"
                    className={classes.Honeypot}
                    tabIndex="-1"
                    autoComplete="off"
                    value={honeypot}
                    onChange={(event) => setHoneypot(event.target.value)}
                />
                <input
                    type="email"
                    name="email"
                    className={classes.Input}
                    placeholder="Enter your email address"
                    aria-label="Email address"
                    value={email}
                    onChange={(event) => {
                        setEmail(event.target.value);
                        if (status === 'error') {
                            setStatus('idle');
                            setMessage('');
                        }
                    }}
                />
                <button type="submit" className={classes.Button} disabled={status === 'sending'}>
                    {status === 'sending' ? 'Subscribing…' : 'Notify Me'}
                </button>
            </form>
            {status === 'error' ? <div className={classes.ErrorMessage}>{message}</div> : null}
        </div>
    );
};

export default NewsletterForm;
